const actions = {
    MYPRODUCT_DETAILS_START: 'MYPRODUCT_DETAILS_START',
    MYPRODUCT_DETAILS_SUCCESS: 'MYPRODUCT_DETAILS_SUCCESS',
    MYPRODUCT_DETAILS_FAILURE: 'MYPRODUCT_DETAILS_FAILURE',

    PRODUCT_PRICE_START: 'PRODUCT_PRICE_START',
    PRODUCT_PRICE_SUCCESS: 'PRODUCT_PRICE_SUCCESS',
    PRODUCT_PRICE_FAILURE: 'PRODUCT_PRICE_FAILURE',

    CLEAR_PRICE_START: 'CLEAR_PRICE_START',
    CLEAR_PRICE_SUCCESS: 'CLEAR_PRICE_SUCCESS',
    CLEAR_PRICE_FAILURE: 'CLEAR_PRICE_FAILURE',
}

export default actions;